import store from "@/store";

export function isAdmin() {
  let user = store.state.users.currentUser;

  return user.role.includes("admin");
}
